<template>
  <div class="dialog-form">
    <el-dialog v-if="isShow" v-model="isShow" :title="title" width="800px" @close="close">
      <el-button type="primary" @click="openChangeServe">添加服务</el-button>
      <div class="coupons-list" style="margin-top: 10px;">
          <el-table ref="dataTableRef" v-if="isShow" :data="dataList" highlight-current-row height="400px">
            <el-table-column label="服务名称" prop="serveName" align="center" />
            <el-table-column label="原售价" prop="price" align="center"/>
            <el-table-column label="折扣" prop="discount" align="center">
              <template #default="scope">
                <el-input-number :controls="false" v-model="scope.row.discount" :min="1" :max="10" :precision="1"
                    style="width: 80%;"></el-input-number>
                <span style="margin-left: 10px">折</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="scope">
                <el-button @click="handleRemove(scope.$index)" type="danger">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      <template #footer>
        <el-button @click="close">取消</el-button>
        <el-button @click="handleSaveClick()" type="primary">保存</el-button>
      </template>
    </el-dialog>
    <ChangeServe ref="ChangeServe" @saveForm="saveServeList"></ChangeServe>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref, watch, computed, onUnmounted, nextTick, handleError } from 'vue'
import { ElMessage } from 'element-plus'
import ChangeServe from './changeServe.vue'

export default defineComponent({
  props: {
  },
  components: {
    ChangeServe
  },
  setup(props, { emit }) {
    const isShow = ref(false)
    const title = ref('服务折扣')
    const formType = ref(null)
    const dataList = ref([])
    const couponListSelecd = ref([])
    const checkedCouponList = ref([])
    const ChangeServe = ref(null)
    const handleSelectionChange = (value) =>{
      couponListSelecd.value=value.map(item=>{
        return item.id
      })
      checkedCouponList.value = value
    }
    const dataTableRef = ref()
    const open = (data) =>{
      isShow.value = true
      dataList.value = JSON.parse(JSON.stringify(data))
    }
    const close = () =>{
      couponListSelecd.value = []
      isShow.value = false
    }
    const openChangeServe = ()=>{
      ChangeServe.value.open(dataList.value)
    }
    const saveServeList = (data) => {
      data.map(i=>{
        i.couponId=i.id
      })
      dataList.value = [...dataList.value,...data]
    }
    const handleRemove = (i) =>{
      dataList.value.splice(i,1)
    }

    const handleSaveClick = async () => {
      // if (dataList.value.length == 0) {
      //   ElMessage({
      //     message: '请选择服务！',
      //     type: 'warning',
      //   })
      //   return
      // } 
      // else if (dataList.value.length > 15) {
      //   ElMessage({
      //     message: '优惠券最多可选15张！',
      //     type: 'warning',
      //   })
      //   return
      // }
      // let couponIds = dataList.value.map(item => {
      //   return {
      //     couponId: item.id,
      //     count: item.count,
      //     benefitsAmount: item.benefitsAmount,
      //   }
      // })
      let isHasNoCount = dataList.value.some(item => isNaN(item.discount))
      if (isHasNoCount) {
        ElMessage({
          message: '请检查服务折扣是否填写完整！',
          type: 'warning',
        })
        return
      }
      emit('saveForm', dataList.value)
      close()
    }

    return {
      handleSaveClick,
      isShow,
      title,
      open,
      close,
      formType,
      dataList,
      handleSelectionChange,
      couponListSelecd,
      dataTableRef,
      ChangeServe,
      openChangeServe,
      saveServeList,
      handleRemove
    }

  }
})
</script>

<style scoped lang="less">
.dialog-form {
  z-index: 999;

  .teacher {
    display: flex;
    flex-wrap: wrap;

    .active {
      background-color: rgb(255, 162, 68);
      color: white;
    }

    .item {
      border-radius: 6px;
      cursor: pointer;
      padding: 0 10px;
      width: 140px;
      line-height: 45px;
      margin: 0 10px;
      border: 1px solid rgba(217, 217, 217, .8);
    }

  }

  &:deep(.el-scrollbar) {
    padding-right: 20px;
  }



}
</style>
